const getStorage = function (type = 'localStorage') {
    if (typeof window === 'undefined') {
        return null
    }

    try {
        return window[type] || null
    } catch (error) {
        return null
    }
}

const getItem = function (key, type = 'localStorage') {
    const storage = getStorage(type)

    if (!storage) {
        return null
    }

    try {
        return storage.getItem(key)
    } catch (error) {
        return null
    }
}

const setItem = function (key, value, type = 'localStorage') {
    const storage = getStorage(type)

    if (!storage) {
        return false
    }

    try {
        storage.setItem(key, value)
        return true
    } catch (error) {
        return false
    }
}

const removeItem = function (key, type = 'localStorage') {
    const storage = getStorage(type)

    if (!storage) {
        return false
    }

    try {
        storage.removeItem(key)
        return true
    } catch (error) {
        return false
    }
}

const clear = function (type = 'localStorage') {
    const storage = getStorage(type)

    if (!storage) {
        return false
    }

    try {
        storage.clear()
        return true
    } catch (error) {
        return false
    }
}

export default {
    getItem,
    setItem,
    removeItem,
    clear,
    get(key, type = 'localStorage') {
        const value = getItem(key, type)

        if (!value) {
            return null
        }

        try {
            return JSON.parse(value)
        } catch (error) {
            return null
        }
    },
    save(key, state, type = 'localStorage') {
        return setItem(key, JSON.stringify(state), type)
    },
    delete(key, type = 'localStorage') {
        return removeItem(key, type)
    },
}
